(function() {
  const descriptionAccordion = document.querySelector('.disclosure__content.product-description');
  const productDimensions = document.getElementById('dimensionsTable');
  const selectorStyle = productDimensions ? productDimensions.dataset.selectorStyle : undefined;

  document.addEventListener('DOMContentLoaded', () => {
    if (productDimensions) {
      setVariantWeight(productDimensions);
    }
  });
  
  document.addEventListener('on:variant:change', () => {
    if (productDimensions) {
      setVariantWeight(productDimensions);
    }
    
    if (descriptionAccordion) {
      handleDescriptionAccordion(descriptionAccordion);
    }
  });

  document.addEventListener('on:cart:add', (event) => {
    let isPersonalised = false;

    // Check if the latest item in the cart is personalised
    if (event.detail.cart.items[0].properties._cartId) {
      isPersonalised = true;
    }

    if (isPersonalised || !window.location.pathname.includes('/cart')) {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
        bubbles: true
      }));
    }
  });

  // Set the weight, width and height values on the product dimensions table based on active variant
  function setVariantWeight(table) {
    // Get the active value from the custom-select dropdown menu
    let weight = '';
    if (selectorStyle === "buttons") {
      weight = document.querySelector('.option-selector input:checked').value;
    } else {
      weight = document.querySelector("variant-picker .custom-select__option[aria-selected='true']").dataset.value;
    }

    if (weight === '' || !weight.includes('g')) return;

    const tableWidth = table.querySelector('#variantWidth');
    const tableLength = table.querySelector('#variantLength');
    const tableWeight = table.querySelector('#variantWeight');

    tableWidth.dataset.variantWidth.split(',').forEach(width => {
      if (width.includes(weight)) {
        tableWidth.innerHTML = `${width.split('-')[0]}mm`;
      }
    });

    tableLength.dataset.variantLength.split(',').forEach(length => {
      if (length.includes(weight)) {
        tableLength.innerHTML = `${length.split('-')[0]}mm`;
      }
    });

    if (tableWeight && weight) tableWeight.innerHTML = weight;
  }

  // Switches between different product descriptions based on the sku value
  function handleDescriptionAccordion(accordion) {
    const targetSku = document.querySelector('.product-sku__value').innerHTML;
    if (accordion.querySelector(`#${targetSku}`)) {
      accordion.querySelector('.active').classList.remove('active');
      accordion.querySelector(`#${targetSku}`).classList.add('active');
    }
  }
}());